import request from '@/utils/request'

/**
 * 套餐列表
 * @param {*} params token, userId
 * @returns
 */
export const packageList = params => {
  return request({
    method: 'get',
    url: '/mobile/package/list',
    params: params
  })
}

/**
 * 流量包充值
 * @param {*} params { iccid：iccidnum }
 * @returns
 */
export const rechargePackage = params => {
  return request({
    method: 'POST',
    url: '/mobile/package/recharge',
    params
  })
}
